import { Divider as MantineDivider, DividerFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import type { IProps } from "./divider.types";

const Divider = componentWrapper<DividerFactory, IProps>("Divider", (props, ref) => {
    return <MantineDivider ref={ref} {...props} />;
});

export { Divider };
